import { call, put, takeEvery } from "redux-saga/effects"
import {
    getUserBirthChartListSuccess,
    getUserBirthChartListFail
} from "./actions"

import { GET_BIRTH_CHART_REPORT, GET_USER_BIRTH_CHART_LIST } from "./actionTypes"
import { getBirthChartReport, getUserBirthChartList } from "../../../helpers/backend_helper"
import { isEmpty } from "lodash"
import { getUserRole } from "components/Common/Roles"

function* fetchUserBirthChartList({ payload }) {
    try {
        console.log("paylod=userName" + payload.userName)
        console.log("paylod=refferedBy" + payload.refferedBy)
        const response = yield call(getUserBirthChartList, {
            params: {
                page: payload.page, size: payload.size,
                sortOrder: payload.sortOrder, createdDate:payload.reportCreatedDate, createdEndDate:payload.reportCreatedEndDate, planet: payload.planet + '##' + payload.position, userName: payload.userName,
                refferedBy: payload.refferedBy, city: payload.city, mobile: payload.mobile, userType: payload.userType,
                groupMasterId: payload.groupMasterId, branchId: payload.branchId, userId: payload.userId
            }
        })
        yield put(getUserBirthChartListSuccess({
            userBirthChartList: response.content,
            page: response.page,
            size: response.size,
            sortOrder: payload.sortOrder,
            totalPages: response.totalPages,
            totalElements: response.totalElements,
            numberOfElements: response.numberOfElements,
        }))
    } catch (error) {
        if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
            yield put(getUserBirthChartListFail(error.response.data.message))
        } else {
            yield put(getUserBirthChartListFail(error.message))
        }
    }
}

function* fetchBirthChartReport({ birthChartId }) {
    try {
        console.log("inside fetchBirthChartPDF saga ::::::::::::::")
        console.log(birthChartId)
        let userRoles = {
            user: false,
            groupUser: false,
            productAdmin: false,
        }
        if (sessionStorage.getItem("userRoles")) {
            let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
            if (savedUserRoles !== undefined) {
                userRoles = savedUserRoles;
            }
        }

        let response;
        if (userRoles.productAdmin) {
            response = yield call(getBirthChartReport, birthChartId)
            const filename = response.headers.get('Content-Disposition').split('filename=')[1];
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
            });
        }
        console.log("response")
        console.log(response)
    } catch (error) {
        console.log(error)
    }
}

function* productAdminBirthChartSaga() {
    yield takeEvery(GET_USER_BIRTH_CHART_LIST, fetchUserBirthChartList)
    yield takeEvery(GET_BIRTH_CHART_REPORT, fetchBirthChartReport)
}

export default productAdminBirthChartSaga